/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type PromoFragment = {
  readonly __typename: "Promo";
  readonly id: c.PromoId;
  readonly code: c.PromoCode;
  readonly trialDays: number | null;
};

export type PromoSignupViewQueryVariables = Types.Exact<{
  promoCode: Types.Scalars["PromoCode"]["input"];
}>;

export type PromoSignupViewQuery = {
  readonly __typename: "Query";
  readonly getPromo: {
    readonly __typename: "Promo";
    readonly id: c.PromoId;
    readonly code: c.PromoCode;
    readonly trialDays: number | null;
  } | null;
};

export const PromoFragmentDoc = /*#__PURE__*/ gql`
  fragment PromoFragment on Promo {
    id
    code
    trialDays
  }
`;
export const PromoSignupViewDocument = /*#__PURE__*/ gql`
  query PromoSignupView($promoCode: PromoCode!) {
    getPromo(promoCode: $promoCode) {
      id
      ...PromoFragment
    }
  }
  ${PromoFragmentDoc}
`;

/**
 * __usePromoSignupViewQuery__
 *
 * To run a query within a React component, call `usePromoSignupViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoSignupViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoSignupViewQuery({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function usePromoSignupViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    PromoSignupViewQuery,
    PromoSignupViewQueryVariables
  > &
    (
      | { variables: PromoSignupViewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PromoSignupViewQuery, PromoSignupViewQueryVariables>(
    PromoSignupViewDocument,
    options,
  );
}
export function usePromoSignupViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PromoSignupViewQuery,
    PromoSignupViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PromoSignupViewQuery,
    PromoSignupViewQueryVariables
  >(PromoSignupViewDocument, options);
}
export function usePromoSignupViewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PromoSignupViewQuery,
    PromoSignupViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PromoSignupViewQuery,
    PromoSignupViewQueryVariables
  >(PromoSignupViewDocument, options);
}
export type PromoSignupViewQueryHookResult = ReturnType<
  typeof usePromoSignupViewQuery
>;
export type PromoSignupViewLazyQueryHookResult = ReturnType<
  typeof usePromoSignupViewLazyQuery
>;
export type PromoSignupViewSuspenseQueryHookResult = ReturnType<
  typeof usePromoSignupViewSuspenseQuery
>;
export type PromoSignupViewQueryResult = Apollo.QueryResult<
  PromoSignupViewQuery,
  PromoSignupViewQueryVariables
>;
